import type { IconData } from '@stacksjs/iconify-core'

export const alignCenter: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M16 64h480v32H16zm80 88h320v32H96zm-80 88h480v32H16zm80 88h320v32H96zm-80 88h480v32H16z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default alignCenter
